<template>
  <div id="UsersView">
    <div class="px-4 inner-container stand-alone">
      <b-row class="inner-row pt-2">
        <b-col cols="12" class="inner-col d-flex flex-column">
          <b-card no-body class="h-100 bg-dark-navy custom border-0">
          <template v-slot:header>
            <b-row>
              <b-col>
                <h6 class="color-white mb-0 mt-1">User Management</h6>
              </b-col>
              <b-col class="text-right">
                <b-button-group size="sm">
                  <b-button class="font-weight-400 bg-transparent color-white mr-2" @click="getUsers">
                    Refresh <font-awesome-icon icon="sync-alt" class="ml-1"></font-awesome-icon>
                  </b-button>
                  <b-button class="font-weight-400 bg-transparent color-white mr-2" @click="$bvModal.show('register-modal')">
                    Create New User <font-awesome-icon icon="user-plus" class="ml-1"></font-awesome-icon>
                  </b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </template>
          <b-card-body class="h-100 p-0 overflow-y scroll-overflow">
            <b-table
              hover
              :items="users"
              :fields="fields"
              :busy="isBusy"
              responsive
              class="mb-0 custom-table text-white border-0"
            >
              <template #table-busy>
                <div class="text-center text-white my-4">
                  <b-spinner class="align-middle color-yellow"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>

              <template #cell(name)="data">
                <div class="py-2 pl-3">
                  <strong class="color-white">{{ data.item.personal ? data.item.personal.fullname : "Unknown" }}</strong><br />
                  <small class="color-yellow">{{ data.item.personal ? data.item.personal.email : "" }}</small>
                </div>
              </template>

              <template #cell(roles)="data">
                <div class="d-flex flex-wrap pt-2 pb-2 role-toggles">
                  <b-form-checkbox
                    switch
                    v-model="data.item.approved"
                    @change="updateUserRoleLocal(data.item, 'approved', $event)"
                    >Approved</b-form-checkbox
                  >
                  <b-form-checkbox
                    switch
                    v-model="data.item.active"
                    @change="updateUserRoleLocal(data.item, 'active', $event)"
                    >Active</b-form-checkbox
                  >
                  <b-form-checkbox
                    switch
                    v-model="data.item.administrator"
                    @change="updateUserRoleLocal(data.item, 'administrator', $event)"
                    >Admin</b-form-checkbox
                  >
                  <b-form-checkbox
                    switch
                    v-model="data.item.staff"
                    @change="updateUserRoleLocal(data.item, 'staff', $event)"
                    >Staff</b-form-checkbox
                  >
                  <b-form-checkbox
                    switch
                    v-model="data.item.trainer"
                    @change="updateUserRoleLocal(data.item, 'trainer', $event)"
                    >Trainer</b-form-checkbox
                  >
                  <b-form-checkbox
                    switch
                    v-model="data.item.displayai"
                    @change="updateUserRoleLocal(data.item, 'displayai', $event)"
                    >DisplayAI</b-form-checkbox
                  >
                  <b-form-checkbox
                    switch
                    v-model="data.item.validated"
                    @change="updateUserRoleLocal(data.item, 'validated', $event)"
                    >Validated</b-form-checkbox
                  >
                </div>
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Create New User Modal -->
    <b-modal id="register-modal" title="Create New User" @ok="handleRegisterSubmit" ok-title="Register" cancel-title="Cancel" ok-variant="primary" :ok-disabled="isRegistering">
      <b-form @submit.prevent="handleRegisterSubmit">
        <b-form-group label="Full Name" label-for="reg-fullname">
          <b-form-input id="reg-fullname" v-model="newUser.fullname" required placeholder="Enter full name"></b-form-input>
        </b-form-group>

        <b-form-group label="Email" label-for="reg-email">
          <b-form-input id="reg-email" v-model="newUser.email" type="email" required placeholder="Enter email address"></b-form-input>
        </b-form-group>

        <b-form-group label="Mobile" label-for="reg-mobile">
          <b-form-input id="reg-mobile" v-model="newUser.mobile" required placeholder="Enter mobile number"></b-form-input>
        </b-form-group>

        <b-form-group label="Password" label-for="reg-password">
          <b-form-input id="reg-password" v-model="newUser.password" type="password" required placeholder="Enter password"></b-form-input>
        </b-form-group>

        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Qualification" label-for="reg-qualification">
              <b-form-input id="reg-qualification" v-model="newUser.qualification" placeholder="Enter qualification"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="HPCSA Number" label-for="reg-hpcsa">
              <b-form-input id="reg-hpcsa" v-model="newUser.hpcsaNumber" placeholder="Enter HPCSA number"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Company" label-for="reg-company">
              <b-form-input id="reg-company" v-model="newUser.company" placeholder="Enter company"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Position" label-for="reg-position">
              <b-form-input id="reg-position" v-model="newUser.position" placeholder="Enter position"></b-form-input>
            </b-form-group>
          </div>
        </div>
      </b-form>
      <div v-if="registerError" class="text-danger mt-2 text-center">{{ registerErrorMsg }}</div>
    </b-modal>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UsersList',
  data () {
    return {
      fields: [
        { key: 'name', label: 'User Details', sortable: true, thClass: 'pl-4' },
        { key: 'roles', label: 'Roles & Status' }
      ],
      newUser: {
        fullname: '',
        email: '',
        mobile: '',
        password: '',
        qualification: '',
        hpcsaNumber: '',
        company: '',
        position: ''
      }
    }
  },
  computed: {
    ...mapState({
      users: state => state.admin.all.items,
      isBusy: state => state.admin.all.loading,
      isRegistering: state => state.admin.registering,
      registerError: state => state.admin.registerError
    }),
    registerErrorMsg () {
      if (!this.registerError) return ''
      return this.registerError.message || this.registerError.toString()
    }
  },
  mounted () {
    this.getUsers()
  },
  methods: {
    ...mapActions('admin', ['getUsers', 'updateUserRole', 'registerUser']),
    handleRegisterSubmit (bvModalEvent) {
      if (bvModalEvent) {
        bvModalEvent.preventDefault()
      }

      this.registerUser(this.newUser)
        .then(() => {
          this.$bvModal.hide('register-modal')
          this.$bvToast.toast('User successfully registered!', {
            title: 'Success',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000
          })
          this.getUsers() // Refresh the user list
          this.resetNewUserForm()
        })
        .catch(error => {
          console.error('Registration failed', error)
        })
    },
    resetNewUserForm () {
      this.newUser = {
        fullname: '',
        email: '',
        mobile: '',
        password: '',
        qualification: '',
        hpcsaNumber: '',
        company: '',
        position: ''
      }
    },
    updateUserRoleLocal (user, field, newValue) {
      // Create a payload with the updated field based on the user object
      const payload = {
        approved: user.approved,
        active: user.active,
        administrator: user.administrator,
        staff: user.staff,
        trainer: user.trainer,
        displayai: user.displayai,
        validated: user.validated,
        personal: user.personal,
        company: user.company
      }

      // Update the specific field being toggled, to handle Vue 2 reactivity timing
      payload[field] = newValue

      this.updateUserRole({ userId: user._id, payload })
        .then(() => {
          this.$bvToast.toast(
            `Updated ${field} for user ${
              user.personal ? user.personal.fullname : 'Unknown'
            }`,
            {
              title: 'Success',
              variant: 'success',
              solid: true,
              autoHideDelay: 2000
            }
          )
        })
        .catch((error) => {
          console.error('Error updating user role:', error)
          this.$bvToast.toast(`Failed to update ${field}`, {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
          // Revert change locally on error
          user[field] = !newValue
        })
    }
  }
}
</script>

<style scoped>
.custom-table {
  background-color: transparent !important;
}
.custom-table /deep/ thead th {
  background-color: #15385B;
  border-color: #14304c;
  border-top: none;
  border-bottom: 2px solid #081624;
  color: #fff;
  font-weight: bold;
}
.custom-table /deep/ tbody tr {
  background-color: #081624;
  color: #fff;
  transition: background-color 0.2s ease;
}
.custom-table /deep/ tbody tr:hover {
  background-color: #0e243a;
}
.custom-table /deep/ tbody td {
  border-color: #14304c;
  vertical-align: middle;
}
.custom-table /deep/ tbody tr:nth-of-type(odd) {
  background-color: #0a1b2c;
}

.role-toggles > div {
  margin-right: 20px;
  display: inline-block;
  margin-bottom: 10px;
}

.role-toggles /deep/ .custom-control-label::before {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.1);
}
.role-toggles /deep/ .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #F0B93B;
  transform: translateX(0.75rem);
}
.role-toggles /deep/ .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #15385B;
  border-color: #F0B93B;
}

#UsersView .title {
  color: #ffffff;
  position: absolute;
  top: 0px;
  left: 0px;
}
#UsersView .inner-container {
  padding-top: 40px;
  position: relative;
}

#UsersView .stand-alone {
  margin-top: 62px;
  position: relative;
}
</style>
